import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Listar from '../../../../components/auth/licitacao/listar/andamento'


function ListarLicAndamentoScreen() {

    return (
        <Fragment>
            <Head titulo="Licitações em Andamento" />
            <HeaderLogged />
            <Container>
               <Listar />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListarLicAndamentoScreen;